<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
            :ref="'professionalsCrud'"
            :crudName="$t('Professionals')"
            :newText="$t('Add')+ '  '+$t('New')"
            :table="table"
            :columns="columns"
            :options="options"
            :endPoint="endPoint"
            :enableAdd="true"
            :enableEdit="true"
            :enableDelete="true"
            :enableView="false"
            :enableReset="false"
            :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "professionalsTable",
      showMessageImport: false,
      professionalsCrud: {},
      pages: [],
      url: "",
      columns: [
        "id",
        "name",
        "professional_type_id",
        "email",
        "center_id",
        "actions",
      ],
      tableData: ["id", "name", "professional_type_id", "email", "center_id"],
      optionsOrigin: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "name", "professional_type_id", "email", "center_id"],
        pagination: {
          chunk: 10,
          dropdown: false,
          nav: "scroll"
        },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: this.$t('id'),
          name: this.$t('Name'),
          professional_type_id: this.$t('Type Of Professional'),
          email: this.$t('Email'),
          center_id: this.$t('Central'),
          actions: this.$t('action'),
        },

        texts: {
          filterBy: this.$t('Filter'),
          defaultOption: this.$t('Select'),
        },
        listColumns: {},
        templates: {

          professional_type_id: function (h, row, index) {
            return row.type_professional ? row.type_professional.name : ""
          },

          center_id: function (h, row, index) {
            return row.center ? row.center.name : ""
          },

        },
        requestFunction: function (data) {
          let requestData = {};


          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["center", "typeProfessional"];

          return axios.get(this.url + "?" + query, requestData).catch(
              function (e) {
                this.dispatch("error", e);
              }.bind(this)
          );
        },
      },
      endPoint: "professionals",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  computed: {
    options() {
      const headings = {
        id: this.$t('id'),
        photo: this.$t('image'),
        name: this.$t('Name'),
        professional_type_id: this.$t('Type Of Professional'),
        email: this.$t('Email'),
        center_id: this.$t('Central'),
        actions: this.$t('action'),
      }

      const texts = {
        filterBy: this.$t('Filter'),
        defaultOption: this.$t('Select'),
      }
      return {
        ...this.optionsOrigin,
        texts,
        headings,
      }

    }

  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        photo: "photo",
        name: "name",
        professional_type_id: "typeProfessional[name]",
        email: "email",
        center_id: "center[name]",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },

  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}

.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>
